var module = angular.module('components');
module.component('wgtRefunds', {
    templateUrl: 'components/dashboard/widgets/wgtRefunds/wgtRefunds.component.tpl.html',
    controllerAs: 'vm',
    bindings: {
        item: '<'
    },
    controller: ['DashboardApiService','$rootScope','$state',controller]
});


function controller(DashboardApiService,$rootScope, $state)  {
    var vm = this;

    vm.widgetData = null;
    vm.isLoaded = false;
    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.$onDestroy = onDestroy;

    vm.gotoArticle = gotoArticle;

    function onInit() {
        $rootScope.$on("widget.changed",function(event, item) {
            if (vm.item.id === item.id) {
                vm.item = item;
                loadWidget();
            }
        });
    }

    function gotoArticle(articleId) {
        $state.go('stock.articlesearch.article', { articleId: articleId });
    }

    function onChanges(changes) {
        loadWidget();
    }

    function loadWidget() {
        vm.isLoaded = false;
        DashboardApiService
            .getWidgetData(vm.item.name, vm.item.setting)
            .then(onNewData,onNewDataError);
    }


    function onNewData(response) {
        vm.widgetData = response.data;
        vm.isLoaded = true;
        vm.hasError = false;
    }

    function onNewDataError(response) {
        vm.hasError = true;
    }

    function onDestroy() {

    }

}
